import React from "react";
import { FaRobot } from "react-icons/fa";

const TypingIndicator = () => (
    <div className="flex gap-2.5 justify-start">
        <div className="w-8 h-8 rounded-full bg-[#2148C0] text-white flex items-center justify-center shrink-0">
            <FaRobot size={13} />
        </div>
        <div className="rounded-2xl rounded-bl-md px-4 py-3 text-sm bg-gray-50 border border-gray-100 text-gray-500 flex items-center gap-2">
            <span>Teechaa is typing</span>
            <span className="flex gap-1">
                <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
                <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
                <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
            </span>
        </div>
    </div>
);

export default TypingIndicator;
